module.exports = __webpack_public_path__ + "static/media/elks-dap-logo-RGB-lightmode.611e2adb.png";